import styled, { css } from 'styled-components';

export const Card = styled.div`
  margin-bottom: 1.5rem;
  padding: 1.4rem 1.6rem;
  border-radius: 5px;
  background-color: ${(p) => p.theme.components}80;
  background-clip: padding-box;
  box-shadow: ${(p) =>
    `0 2px 2px -2px ${p.theme.accent.primary}45,
    0 3px 1px -3px ${p.theme.accent.primary}45, 
    0 1px 5px -2px ${p.theme.accent.primary}45`};
  z-index: 1;

  @media screen and (max-width: 768px) {
    padding: 0.8rem 1rem;
  }

  ${(p) =>
    p.zeroPadding &&
    css`
      padding: 0;

      @media screen and (max-width: 768px) {
        padding: 0;
      }
    `}

  ${(p) =>
    p.borderLeft &&
    css`
      border-left: 6px solid ${(p) => p.theme.accent.primary}90;
    `}

  ${(p) =>
    p.bottomMargin &&
    css`
      margin-bottom: 5rem;

      @media screen and (max-width: 768px) {
        margin-bottom: 2rem;
      }
    `}
`;

export default Card;
